import { isAxiosError } from 'axios'
import { api } from '@/lib/api'

export interface SecurityLookup {
  symbol: string
  name: string
  currency: string | null
}

export async function lookupSecurity(query: string): Promise<SecurityLookup | null> {
  try {
    const { data } = await api.get<SecurityLookup>('/market-data/lookup', {
      params: { q: query },
    })
    return data
  } catch (err) {
    if (isAxiosError(err) && err.response?.status === 404) return null
    throw err
  }
}
